/** DIA-01 — speaker segment normalisation and label helpers */

export const normalizeSpeakerSegment = (segment, index) => ({
  id: segment.id ?? `seg-${index}`,
  speaker_label: segment.speaker_label || segment.speaker || `Speaker ${index + 1}`,
  role_name: segment.role_name || segment.display_name || '',
  start_time_seconds: Number(segment.start_time_seconds ?? segment.start ?? 0),
  end_time_seconds: Number(segment.end_time_seconds ?? segment.end ?? 0),
  text: segment.text || segment.content || '',
  confidence_score:
    segment.confidence_score != null ? Number(segment.confidence_score) : null,
});

export const normalizeSpeakerSegments = (segments) => {
  if (!Array.isArray(segments) || segments.length === 0) return [];
  return segments.map(normalizeSpeakerSegment);
};

export const getSpeakerDisplayName = (segment, labelMap = {}) => {
  if (segment.role_name) return segment.role_name;
  const key = segment.speaker_label;
  if (key && labelMap[key]) return labelMap[key];
  return key || 'Unknown speaker';
};

export const applySpeakerLabelMap = (segments, labelMap = {}) =>
  segments.map((seg) => ({
    ...seg,
    role_name: labelMap[seg.speaker_label] || seg.role_name || '',
  }));

export const getUniqueSpeakerLabels = (segments) =>
  [...new Set(segments.map((s) => s.speaker_label).filter(Boolean))];

export const getConfidenceLevel = (score) => {
  if (score == null || Number.isNaN(score)) return null;
  if (score >= 0.9) return 'high';
  if (score >= 0.75) return 'medium';
  return 'low';
};

export const confidenceLabel = (score) => {
  const level = getConfidenceLevel(score);
  if (!level) return null;
  if (level === 'high') return 'High confidence';
  if (level === 'medium') return 'Medium confidence';
  return 'Low confidence';
};

export const segmentsToPlainText = (segments, labelMap = {}) =>
  segments
    .map((seg) => {
      const name = getSpeakerDisplayName(seg, labelMap);
      return `${name}: ${seg.text}`;
    })
    .join('\n\n');

export const buildLabelMapFromSegments = (segments) => {
  const map = {};
  segments.forEach((seg) => {
    if (seg.speaker_label && seg.role_name) {
      map[seg.speaker_label] = seg.role_name;
    }
  });
  return map;
};
